const usePermissionConfig = () => {
  return {
    // 日志详情
    RZXQ: 'OPS-XXZX-RZGL-RZXQ',
  };
};

export default usePermissionConfig;
